<template>
     <Breadcrumbs main="Apps" title="Social App" />
      <div class="container-fluid">
            <div class="user-profile social-app-profile">
  <socialHeader />
            </div>
      </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const socialHeader = defineAsyncComponent(() => import("@/components/theme/socialapp/socialHeader.vue"))
</script>